import styled from '@emotion/styled-base';
import { ReactSVG } from 'react-svg';

export const SVGImg = styled(ReactSVG)<{ width?: string }>`
  svg {
    width: ${(props) => props.width ?? '100%'};
    height: auto;
  }
`;
